import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox, Col, Form, Input, Row, TimePicker
} from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = ({ dataSource }) => {
  const {
    reference_number, carrier, departure_time, arrival_time, active
  } = dataSource;

  return {
    reference_number: Form.createFormField({ value: reference_number }),
    carrier: Form.createFormField({ value: carrier }),
    departure_time: Form.createFormField({ value: departure_time }),
    arrival_time: Form.createFormField({ value: arrival_time }),
    active: Form.createFormField({ value: active })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin,
  checkboxFormItemLayout,
  dataSource,
  form,
  inputFormItemLayout
}) => {
  const { getFieldDecorator } = form;
  const {
    reference_number, carrier, departure_time, arrival_time, active
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <Row {...inputFormItemLayout.row}>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...inputFormItemLayout.inputLayout} label="Reference">
            {getFieldDecorator('reference_number', {
              initialValue: reference_number,
              rules: [
                {
                  required: true,
                  message: 'Please enter the Reference.'
                }
              ]
            })(<Input maxLength={255} disabled={readonly} />)}
          </FormItem>
        </Col>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...inputFormItemLayout.inputLayout} label="Departure Time">
            {getFieldDecorator('departure_time', {
              initialValue: departure_time,
              rules: [
                {
                  required: true,
                  message: 'Please enter the Departure Time.'
                }
              ]
            })(<TimePicker disabled={readonly} format="HH:mm" />)}
          </FormItem>
        </Col>
      </Row>
      <Row {...inputFormItemLayout.row}>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...inputFormItemLayout.inputLayout} label="Carrier">
            {getFieldDecorator('carrier', {
              initialValue: carrier
            })(<Input disabled={readonly} />)}
          </FormItem>
        </Col>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...inputFormItemLayout.inputLayout} label="Arrival Time">
            {getFieldDecorator('arrival_time', {
              initialValue: arrival_time,
              rules: [
                {
                  required: true,
                  message: 'Please enter the Arrival Time.'
                }
              ]
            })(<TimePicker disabled={readonly} format="HH:mm" />)}
          </FormItem>
        </Col>
      </Row>
      <Row {...inputFormItemLayout.row}>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...checkboxFormItemLayout}>
            {getFieldDecorator('active', {
              initialValue: active,
              valuePropName: 'checked'
            })(<Checkbox disabled={readonly}>Active</Checkbox>)}
          </FormItem>
        </Col>
        <Col {...inputFormItemLayout.col} />
      </Row>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  readonly: PropTypes.bool
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  readonly: false
};

const RouteLegInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default RouteLegInput;
